import { ChevronDownIcon, ChevronRightIcon, UserPlusIcon } from "lucide-react";

import { Row, Text } from "@/components";
import { Button } from "@/components/ui/button";
import { TableCell, TableRow } from "@/components/ui/table";

import { pipelineStageToLabel } from "@/lib/constants";
import { PipelineStage } from "@/types";

export const CollapsibleStageRow = ({
  stage,
  rowCount,
  isCollapsed,
  colSpan,
  onToggleCollapsed,
  onAddCandidate,
  onReviewAllApplied,
}: {
  stage: PipelineStage;
  rowCount: number;
  isCollapsed: boolean;
  colSpan: number;
  onToggleCollapsed: () => void;
  onAddCandidate: () => void;
  onReviewAllApplied: () => void;
}) => {
  /* Render */
  const render = () => (
    <TableRow
      className="sticky top-12 z-20 cursor-pointer border-b-0"
      onClick={onToggleCollapsed}
    >
      <TableCell
        colSpan={colSpan}
        className="relative z-20 border-b border-slate-200 bg-slate-100 px-4 py-2.5 hover:bg-slate-200"
      >
        <Row className="min-h-8 items-center justify-between gap-1.5">
          <Row className="min-w-0 items-center gap-1.5">
            <Button
              className="h-6 w-6 shrink-0 text-slate-600 hover:bg-slate-200/80 hover:text-slate-900"
              onClick={(e) => {
                e.stopPropagation();
                onToggleCollapsed();
              }}
              variant="ghost"
            >
              {isCollapsed ? <ChevronRightIcon /> : <ChevronDownIcon />}
            </Button>
            <Text className="text-xs font-semibold uppercase tracking-wide text-slate-600">
              {pipelineStageToLabel[stage]}
            </Text>
            <Text className="text-xs text-slate-400">·</Text>
            <Text className="text-xs tabular-nums">
              {rowCount.toLocaleString()}
            </Text>
            <Button
              className="h-7 w-7 shrink-0 text-slate-600 hover:bg-slate-200/80 hover:text-slate-900"
              onClick={(e) => {
                e.stopPropagation();
                onAddCandidate();
              }}
              variant="ghost"
            >
              <UserPlusIcon />
            </Button>
          </Row>
          {stage === PipelineStage.APPLIED && (
            <Button
              className="h-8 shrink-0 text-xs"
              onClick={(e) => {
                e.stopPropagation();
                onReviewAllApplied();
              }}
              size="sm"
              variant="outlineSecondary"
            >
              Review all ({rowCount.toLocaleString()})
            </Button>
          )}
        </Row>
      </TableCell>
    </TableRow>
  );

  return render();
};
